export default __webpack_public_path__ + "static/media/965.2cc9a0ba.gif";